import { defineComponent as _defineComponent } from 'vue'
import { inject } from 'vue';

import { HelperViewStatus } from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'HandleError',
  setup(__props) {

const fetchInitialData = inject('fetchInitialData', () => ({}));

return { __sfc: true,fetchInitialData, HelperViewStatus }
}

})